import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import {
  IInventoryLocation,
  IInventoryLocationForm,
  IInventoryLocationType,
} from '@/models/inventory.locations';

import { http } from './http';
import { IGetParams, IListResponse, IPaginatedListResponse } from './types';

export const InventoryLocationApi = {
  list: async (
    params: IGetParams,
  ): Promise<AxiosResponse<IListResponse<IInventoryLocation>>> => {
    return http.get(`api/${ApiVersion.V1}/inventory-locations/`, { params });
  },
  paginatedList: async (
    params: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IInventoryLocation>>> => {
    return http.get(`api/${ApiVersion.V1}/inventory-locations/list`, {
      params,
    });
  },
  getOne: async (id: string): Promise<AxiosResponse<IInventoryLocation>> => {
    return http.get(`api/${ApiVersion.V1}/inventory-locations/${id}`);
  },
  getTypes: async (): Promise<AxiosResponse<IInventoryLocationType[]>> => {
    return http.get(`api/${ApiVersion.V1}/inventory-locations/types`);
  },
  save: async (
    data: IInventoryLocationForm,
  ): Promise<AxiosResponse<IInventoryLocation>> => {
    return data._id
      ? InventoryLocationApi.update(data._id, data)
      : InventoryLocationApi.create(data);
  },
  create: async (
    data: IInventoryLocationForm,
  ): Promise<AxiosResponse<IInventoryLocation>> => {
    return http.post(`api/${ApiVersion.V1}/inventory-locations`, data);
  },
  update: async (
    id: string,
    data: IInventoryLocationForm,
  ): Promise<AxiosResponse<IInventoryLocation>> => {
    return http.put(`api/${ApiVersion.V1}/inventory-locations/${id}`, data);
  },
  delete: async (id: string): Promise<AxiosResponse> => {
    return http.delete(`api/${ApiVersion.V1}/inventory-locations/${id}`);
  },
  removeParent: async (
    id: string,
  ): Promise<AxiosResponse<IInventoryLocation>> => {
    return http.patch(
      `api/${ApiVersion.V1}/inventory-locations/${id}/remove-parent`,
    );
  },
};
